<template>
  <PortableText :value="blocks" :components="portableTextComponents" />
</template>

<script>
import { h } from 'vue'
import { PortableText } from '@portabletext/vue'
import sanity from "../../client";
import imageUrlBuilder from "@sanity/image-url";

const imageBuilder = imageUrlBuilder(sanity);

export default {
  name: 'SanityBlocks',
  components: { PortableText },
  props: {
    blocks: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      portableTextComponents: {
        types: {
          image: ({ value }) => {
            if (!value?.asset?._ref) {
              return null
            }

            return h('img', {
              src: this.imageUrlFor(value.asset._ref).width(800).url(),
              alt: value.alt || '',
              class: 'img-fluid mx-auto my-3',
            })
          }
        }
      }
    }
  },
  methods: {
    imageUrlFor(source) {
      console.log(source);
      return imageBuilder.image(source)
    }
  }
}
</script>
